exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".closed-sidebar #header-logo h1{font-size:25px}#header-logo a{color:#fff!important}.closed-sidebar #close-sidebar{right:0!important}.user-account-btn dropdown open .dropdown-menu{display:block}h1 small{font-size:40%;font-weight:300;color:#fff}#header-logo h1{font-family:Nunito,sans-serif}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/topbar/topbar.scss
// module id = 979
// module chunks = 0